<template>
<div>
    <b-dropdown id="ddown1" @hide="hideHandler" @show="showHandler" size="md" variant="default" class="date-range-open-btn">
        <template slot="button-content">
            {{ buttonTitle }} <span v-if="filterString">- </span>{{ filterString }} <span v-if="dpDays && selected=='rolling'"> Days</span>
        </template>
        <b-dropdown-item style="min-width: 250px;">
            <div style="display: inline-block;">
                <select v-model="selected" @change="selectChanged" class="form-control form-control-sm">
                    <option selected value="">-- Data Filter Type --</option>
                    <option value="between">Between</option>
                    <option value="gt">Greater Than</option>
                    <option value="gte">Greater Than Or Equal To</option>
                    <option value="lt">Less Than</option>
                    <option value="lte">Less Than Or Equal To</option>
                    <option value="mtd">Month To Date</option>
                    <option value="rolling">Rolling - Past</option>
                    <option value="rolling_future">Rolling - Future</option>
                    <option value="ytd">YTD</option>
                    <option value="today">Today</option>
                    <option value="past">In the Past</option>
                    <option value="future">In the Future</option>
                </select>
            </div>
            <div style="display: inline-block;">
                <b-button variant="outline-secondary" size="sm" @click="toggleShow" title="Close Filter">
                    <i class="fa fa-times"></i>
                </b-button>
            </div>
        </b-dropdown-item>
        <b-dropdown-item>
            <div v-if="showNoDate">
                No Inputs for this Date Filter Type
            </div>
            <div class="form-group input-group-sm date-filter-options rolling-options" v-if="showRolling">
                <div class="input-group input-group-sm">
                    <div class="input-group-addon">
                        <span v-if="selected === 'rolling'">Last</span>
                        <span v-else-if="selected === 'rolling_future'">Upcoming</span>
                    </div>
                    <input v-model="dpDays" placeholder="Number of Days" class="form-control form-control-sm" @change="updateFilter" />
                    <div class="input-group-addon">Days</div>
                </div>
            </div>
            <div v-if="showSingleDate">
                <date-picker v-model="dpSingle" @dp-change="updateFilter" :config="{format:'MM/DD/YYYY',date:''}" class="form-control form-control-sm" />
            </div>
            <div v-if="showBetweenDates">
                <date-picker v-model="dpFrom" @dp-change="updateFilter" :config="{format:'MM/DD/YYYY',date:''}" />
                To
                <date-picker v-model="dpTo" @dp-change="updateFilter" :config="{format:'MM/DD/YYYY',date:''}" />
            </div>
            <div class="mt-2">
                <b-button variant="success" size="sm" @click="updateFilter(true)">Update Filter</b-button>
                <b-button variant="warning" size="sm" @click="clearFilter">Clear Filter</b-button>
            </div>
        </b-dropdown-item>
    </b-dropdown>
</div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: [ 'buttonTitle', 'value' ],
        data: function() {
            return {
                loading: true,
                selected: '',
                dateRangeBegin: '',
                dateRangeEnd: '',
                showCard: false,
                showSingleDate: false,
                showNoDate: false,
                showRolling: false,
                showBetweenDates: false,
                dpSingle: '',
                dpFrom: '',
                dpTo: '',
                dpDays: '',
                filterString: '',
            }
        },

        methods: {

            hideHandler: function(bvEvt) {
                if(this.showCard){
                    bvEvt.preventDefault();
                }
            },

            showHandler: function() {
                this.showCard = true;
            },

            toggleShow: function() {
                this.showCard = (!this.showCard);
            },

            getLabel(){
                //Setup
                var label = this.selected;

                //Figure out the label
                switch(this.selected)
                {
                    case 'mtd':
                        //Setup the Current Date
                        var now = new moment();

                        //Uppercase
                        label = this.selected.toUpperCase() + ' (As Of: '+now.format('MM/DD/YYYY')+')';
                        break;

                    case 'ytd':
                        //Setup the Current Date
                        var now = new moment();

                        label = this.selected.toUpperCase() + ' (As Of: '+now.format('MM/DD/YYYY')+')';
                        break;

                    case 'between':
                        //Set
                        label = ' ('+this.dpFrom + ' - ' + this.dpTo+')';
                        break;

                    case 'gt':
                    case 'gte':
                        label = 'Greater Than '+(this.selected === 'gte' ? 'Or Equal To' : '')+' ('+this.dpSingle+')';
                        break;

                    case 'lt':
                    case 'lte':
                        label = 'Less Than '+(this.selected === 'lte' ? 'Or Equal To' : '')+' ('+this.dpSingle+')';
                        break;

                    case 'rolling':
                    case 'rolling_future':
                        //Setup the Current Date
                        var now = new moment();

                        label = (this.selected === 'rolling' ? 'Last' : 'Next') + ' '+this.dpDays+' Days (From: '+now.format('MM/DD/YYYY')+')';
                        break;

                    case 'today':
                        //Setup
                        label = 'Today';
                        break;

                    case 'past':
                        //Setup
                        label = 'In the Past';
                        break;

                    case 'future':
                        //Setup
                        label = 'In the Future';
                        break;
                }

                //Send it
                return label;
            },

            setValue(val){
                //Split the parts
                var v = val.split(":");

                //Set the selected
                this.selected = v[0];

                switch(this.selected){
                    case 'mtd':
                    case 'ytd':
                    case 'today':
                    case 'past':
                    case 'future':
                        this.showNoDate = true;
                        break;
                    case 'lt':
                    case 'gt':
                    case 'lte':
                    case 'gte':
                        this.showSingleDate = true;
                        this.dpSingle = v[1];
                        break;
                    case 'between':
                        var w = v[1].split(",");
                        this.dpFrom = w[0];
                        this.dpTo = w[1];
                        this.showBetweenDates = true;
                        break;
                    case 'rolling':
                    case 'rolling_future':
                        this.dpDays = v[1];
                        this.showRolling = true;
                        break;
                }
            },

            selectChanged: function() {
                var theSel = '';
                switch (this.selected) {
                    case 'between':
                        theSel ='showBetweenDates';
                        break;
                    case 'mtd':
                    case 'ytd':
                    case 'today':
                    case 'past':
                    case 'future':
                        theSel = 'showNoDate';
                        break;
                    case 'gt':
                    case 'gte':
                    case 'lt':
                    case 'lte':
                        theSel = 'showSingleDate';
                        break;
                    case 'rolling':
                    case 'rolling_future':
                        theSel = 'showRolling';
                        break;
                }

                this.showBetweenDates = ('showBetweenDates' == theSel);
                this.showRolling = ('showRolling' == theSel);
                this.showSingleDate = ('showSingleDate' == theSel);
                this.showNoDate = ('showNoDate' == theSel);

                this.updateFilter();
            },

            clearFilter: function() {
                this.selected = '';
                this.filterString = '';
                this.dpSingle = '';
                this.dpFrom = '';
                this.dpTo = '';
                this.dpDays = '';
                this.selectChanged();
                this.$emit('clearDateFilter', this.selected);
            },

            updateFilter: function(close) {
                switch(this.selected) {
                    case 'between':
                        this.filterString = this.selected+":"+this.dpFrom+","+this.dpTo;
                        break;
                    case 'gt':
                    case 'lt':
                    case 'gte':
                    case 'lte':
                        this.filterString = this.selected+":"+this.dpSingle;
                        break;
                    case 'mtd':
                    case 'ytd':
                    case 'today':
                    case 'past':
                    case 'future':
                        this.filterString = this.selected;
                        break;
                    case 'rolling':
                    case 'rolling_future':
                        this.filterString = this.selected+":"+this.dpDays;
                        break;
                }

                this.$emit('input', this.filterString);
                if (close === true)
                {
                    this.showCard = false;
                }
            }
        },

        mounted() {
            // Rebuild from the v-model connected variable
            if(this.value)
            {
                //Set thevalue
                this.setValue(this.value);

                //Update the Filters
                this.updateFilter();
            }
        },

    }
</script>

<style>
    .date-range-open-btn > button {
        background-color: #fff;
        border: 1px solid #c6c6c6;
        border-left: 1px solid #c6c6c6 !important;
        border-right: 1px solid #c6c6c6 !important;
        padding: 4px 8px 3px 8px;
        margin-bottom: 1px;
        margin-top: -1px;
    }
</style>
